import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import PortfolioTable from '../components/tables/portfolioTable';

export default function Blogs() {
  return (
    <Box sx={{ py: '20px' }}>
      <Container maxW="container.xl">
        <PortfolioTable />
      </Container>
    </Box>
  );
}
